/**
 * 라우트 관련 store
 */
const chartAnalysis = {
  state: {
    /**
     * 현재 선택된 트리 노드의 메뉴
     * @type {String}
     */
    initChartTemplateSeq: null,
  },
  mutations: {
    setInitChartTemplateSeq: (state, templateSeq) => {
      state.initChartTemplateSeq = templateSeq;
    },
  },
  actions: {
    setInitChartTemplateSeq({ commit }, templateSeq) {
      commit('setInitChartTemplateSeq', templateSeq);
    },
  },
};

export default chartAnalysis;



// WEBPACK FOOTER //
// ./src/store/modules/chart-analysis.js